/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var WarningTriangleIcon24Regular = forwardRef('WarningTriangleIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M13.125 15.928a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0Z" }),
        React.createElement("path", { d: "M12.75 7.845a.75.75 0 1 0-1.5 0v4.407a.75.75 0 0 0 1.5 0V7.845Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.906 3.149c.954-1.57 3.233-1.57 4.188 0l7.985 13.142c.992 1.632-.184 3.722-2.094 3.722H4.015c-1.91 0-3.086-2.09-2.094-3.722L9.906 3.149Zm2.906.779a.95.95 0 0 0-1.624 0L3.203 17.07a.95.95 0 0 0 .812 1.443h15.97a.95.95 0 0 0 .812-1.444L12.812 3.929Z" })));
});
